<template>
  <div class="base-table">
    <table>
      <tr>
        <th v-for="(property, i) in properties" :key="i">
          <div>{{ property.title }}</div>
        </th>
      </tr>
      <tr v-for="(item, i) in items" @click="handleClick(item)" :key="i">
        <td v-for="(property, i) in properties" :key="i">
          <slot :name="property.slot" :item="item" />
        </td>
      </tr>
    </table>

    <div class="filler" v-if="loading">
      <div class="text">Loading</div>
      <BaseSpinner />
    </div>
    <div class="filler button" @click="$emit('fetch-more')" v-if="!loading && !finished">
      <div class="text">Load more</div>
      <img class="icon" src="@/assets/img/arrow-circle-down.svg" />
    </div>
    <div class="filler" v-if="!loading && finished && !items.length">
      <div class="text">No items found</div>
      <img class="icon" src="@/assets/img/smiley-sad.svg" />
    </div>
  </div>
</template>

<script>
import BaseSpinner from '@/components/BaseSpinner/BaseSpinner'
export default {
  components: {
    BaseSpinner
  },
  props: {
    properties: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    },
    finished: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClick(item) {
      this.$emit('selected', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-table {
  width: 100%;
  border: var(--border-1);
  border-radius: var(--br-1);
  background: var(--color-white-1);
  overflow: hidden;
}
table {
  width: 100%;
  border-spacing: 0;
  color: var(--color-gray-3);
  * {
    user-select: text;
  }
}
tr:not(:first-child) {
  cursor: pointer;
  &:hover {
    background: var(--color-gray-1);
  }
  & > * {
    border-top: var(--border-1);
  }
}
th {
  font-weight: var(--fw-medium);
  padding: var(--spacing-3) var(--spacing-4);
  background: var(--color-gray-2);
}
td {
  padding: var(--spacing-4);
}
th,
td {
  &:not(:first-child) {
    padding-left: 0;
  }
  text-align: left;
}
.filler {
  width: 100%;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: var(--border-1);
}
.text {
  color: var(--color-gray-3);
  font-weight: var(--fw-medium);
  margin-right: 6px;
}
.button {
  cursor: pointer;
  &:hover {
    background: var(--color-gray-1);
  }
}
.icon {
  height: 1.4rem;
}
th:first-child {
  width: 100%;
}
</style>
